import type { User } from "#gen/identities/v1/identities_pb.js";
import { browser } from "$app/env";

export function updateDatadogUserAttributes(user: User | undefined) {
	if (!browser) {
		return;
	}

	if (user) {
		window.DD_LOGS?.setUser?.({
			id: user?.id,
		});
		window.DD_RUM?.setUser?.({
			id: user?.id,
			email: user?.email,
		});
	} else {
		window.DD_LOGS?.clearUser?.();
		window.DD_RUM?.clearUser?.();
	}
}

export function updateDatadogOrgWorkspaceAttributes(orgId: string | undefined, workspaceId: string | undefined) {
	if (!browser) {
		return;
	}

	if (orgId) {
		window.DD_LOGS?.setGlobalContextProperty?.("org_id", orgId);
		window.DD_RUM?.setGlobalContextProperty?.("org_id", orgId);
	} else {
		window.DD_LOGS?.removeGlobalContextProperty?.("org_id");
		window.DD_RUM?.removeGlobalContextProperty?.("org_id");
	}
	if (workspaceId) {
		window.DD_LOGS?.setGlobalContextProperty?.("workspace_id", workspaceId);
		window.DD_RUM?.setGlobalContextProperty?.("workspace_id", workspaceId);
	} else {
		window.DD_LOGS?.removeGlobalContextProperty?.("workspace_id");
		window.DD_RUM?.removeGlobalContextProperty?.("workspace_id");
	}
}

export function updateDatadogFeatureFlagAttributes(flag: string, isEnabled: boolean) {
	if (!browser) {
		return;
	}

	window.DD_RUM?.addFeatureFlagEvaluation?.(flag, isEnabled);
}
